import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useWallet } from "@/contexts/WalletContext";

export function useIsAdmin() {
  const { connected, publicKey } = useWallet();

  const { data: isAdmin, isLoading } = useQuery({
    queryKey: ["admin-check", publicKey],
    queryFn: async () => {
      if (!publicKey) return false;
      
      const { data, error } = await supabase.rpc("is_admin", { _wallet: publicKey });
      
      if (error) {
        console.error("Admin check error:", error);
        return false;
      }
      
      return data === true;
    },
    enabled: connected && !!publicKey,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    isAdmin: isAdmin ?? false,
    isLoading,
    isConnected: connected,
  };
}

export function useUserRole() {
  const { connected, publicKey } = useWallet();

  const { data: role, isLoading } = useQuery({
    queryKey: ["user-role", publicKey],
    queryFn: async () => {
      if (!publicKey) return null;
      
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("wallet_address", publicKey)
        .maybeSingle();
      
      return data?.role ?? "user";
    },
    enabled: connected && !!publicKey,
  });

  return {
    role: role ?? "user",
    isLoading,
    isAdmin: role === "admin",
    isModerator: role === "moderator" || role === "admin",
  };
}
